module.exports = __webpack_public_path__ + "static/team-kriggen.8c79fc49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team-kriggen.png
// module id = 976
// module chunks = 263791100135453